import React from "react";
import { cn } from "@/lib/utils";

interface BaseCardProps {
  children: React.ReactNode;
  variant?: "default" | "dark" | "beige";
  padding?: "sm" | "md" | "lg";
  borderRadius?: "sm" | "md" | "lg";
  shadow?: "sm" | "md" | "none";
  className?: string;
}

const BaseCard: React.FC<BaseCardProps> = ({
  children,
  variant = "default",
  padding = "md",
  borderRadius = "md",
  shadow = "md",
  className,
}) => {
  const variantClasses = {
    default: "bg-muted",
    dark: "bg-foreground/5",
    beige: "bg-landing-cream/80",
  };

  const paddingClasses = {
    sm: "p-4",
    md: "p-6",
    lg: "p-6 lg:p-8",
  };

  const borderRadiusClasses = {
    sm: "rounded-lg",
    md: "rounded-xl",
    lg: "rounded-2xl",
  };

  const shadowClasses = {
    sm: "shadow-md",
    md: "shadow-lg",
    none: "",
  };

  return (
    <div
      className={cn(
        "flex flex-col",
        variantClasses[variant],
        paddingClasses[padding],
        borderRadiusClasses[borderRadius],
        shadowClasses[shadow],
        className
      )}
    >
      {children}
    </div>
  );
};

export default BaseCard;
